<template>
  <v-data-table
    v-if="isReady"
    :headers="headers"
    :items="computedItems"
    :options="{
      sortBy: ['dt'],
      sortDesc: [true]
    }"
    class="elevation-1 w-100 receipt-table"
  >
    <template v-slot:item.zScoreStatureValue="{ item }">
      <span class="z-score-value" :class="item.zScoreStatureClass">{{ formatZScoreValue(item.zScoreStatureValue) }}</span>
    </template>
    <template v-slot:item.zScoreWeightValue="{ item }">
      <span class="z-score-value" :class="item.zScoreWeightClass">{{ formatZScoreValue(item.zScoreWeightValue) }}</span>
    </template>
    <template v-slot:item.zScoreBMIValue="{ item }">
      <span class="z-score-value" :class="item.zScoreBMIClass">{{ formatZScoreValue(item.zScoreBMIValue) }}</span>
    </template>
    <template v-slot:header.zScoreText>
        Результат&nbsp;*
    </template>
    <template v-slot:item.zScoreText="{ item }">
      <div class="d-block">
        <p class="z-score-text" :class="item.zScoreStatureClass">{{ item.zScoreStatureText }}.</p>
        <p class="z-score-text" :class="item.zScoreWeightClass">
          <span v-if="item.zScoreBMIClass !== item.zScoreWeightClass">По весу: {{ item.zScoreWeightText.toLowerCase() }}.</span>
          <span v-else>{{ item.zScoreWeightText }}.</span>
        </p>
        <p
          v-if="item.zScoreBMIClass !== item.zScoreWeightClass"
          class="z-score-text" :class="item.zScoreBMIClass"
        >
          <span v-if="item.zScoreBMIClass !== item.zScoreWeightClass">По ИМТ: {{ item.zScoreBMIText.toLowerCase() }}.</span>
          <span v-else>{{ item.zScoreBMIText }}.</span>
        </p>
        <p
          v-if="item.zScoreBMIClass !== item.zScoreWeightClass"
          class="z-score-text grey--text"
        >
            Для уточнения нутритивного статуса необходимо обратиться к профильному специалисту.
        </p>
      </div>
    </template>
    <template v-slot:footer.prepend>
      <div class="result-note">Результат не является диагнозом. <br> Для установления диагноза необходима консультация профильного специалиста.</div>
    </template>
  </v-data-table>
</template>

<script>
import measureDB from '@/app/measure'
import bounds from '@/app/bounds'
import zScore from '@/app/zscore'
import config from '@/app/config'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isReady: false,
      headers: [
        {
          text: 'Дата',
          align: 'center',
          sortable: true,
          value: 'dt',
          cellClass: 'nowrap'
        },
        { text: 'Возраст', value: 'age', align: 'center' },
        { text: 'Рост (см)', value: 'stature', align: 'center' },
        { text: 'Вес (кг)', value: 'weight', align: 'center' },
        { text: 'ИМТ', value: 'bmi', align: 'center' },
        // { text: '%', value: 'persent', align: 'center' },
        { text: 'zScore Рост', value: 'zScoreStatureValue', align: 'center' },
        { text: 'zScore Вес', value: 'zScoreWeightValue', align: 'center' },
        { text: 'zScore ИМТ', value: 'zScoreBMIValue', align: 'center' },
        { text: 'Результат*:', value: 'zScoreText', align: 'left' }
      ]
    }
  },
  computed: {
    computedItems () {
      let items = []
      for (let i in this.items) {
        items[i] = Object.assign({}, this.items[i])
        const bmi = Math.round(measureDB.calcBMI(items[i].weight, items[i].stature) * 100) / 100
        const age = measureDB.getAgeInHuman(this.activeProfile, items[i])
        const ageYears = measureDB.getAgeInYears(this.activeProfile, items[i])
        /*
        for (let j = -50; j < 150; j++) {
          let tempItem = Object.assign({}, items[i])
          tempItem.bmi = bmi
          tempItem.age = age
          tempItem.persent = j
          tempItem.id = j
          const ZS = zScore.calc(tempItem.persent, ageYears)
          tempItem.zScoreBMIValue = ZS.value > 0 ? '+' + ZS.value : ZS.value
          tempItem.zScoreBMIText = ZS.text
          tempItem.zScoreBMIClass = ZS.cls
          items.push(tempItem)
        }
        */
        items[i].bmi = bmi
        items[i].age = age

        const persentile = bounds.getPersent(measureDB.BMI, ageYears, bmi)
        items[i].persent = parseInt(persentile.persent)
        const ZS = zScore.calc(items[i].persent, ageYears)

        items[i].zScoreBMIValue = ZS.value
        items[i].zScoreBMIText = ZS.text
        items[i].zScoreBMIClass = ZS.cls

        const persentileWeight = bounds.getPersent(measureDB.WEIGHT, ageYears, items[i].weight)
        items[i].persentWeight = parseInt(persentileWeight.persent)
        const ZSWeight = zScore.calc(items[i].persentWeight, ageYears)

        items[i].zScoreWeightValue = ZSWeight.value
        items[i].zScoreWeightText = ZSWeight.text
        items[i].zScoreWeightClass = ZSWeight.cls

        // Рост
        const persentileStature = bounds.getPersent(measureDB.STATURE, ageYears, items[i].stature)
        items[i].persentStature = parseInt(persentileStature.persent)
        const ZSStature = zScore.calc(items[i].persentStature, ageYears, 'stature')

        items[i].zScoreStatureValue = ZSStature.value
        items[i].zScoreStatureText = ZSStature.text
        items[i].zScoreStatureClass = ZSStature.cls
      }
      return items
    },
    activeProfile () {
      return this.$store.state.profile
    }
  },
  mounted () {
    bounds.init(this.activeProfile.sex, this.activeProfile.disability).then(() => {
      this.isReady = true
    })
  },
  methods: {
    formatZScoreValue (value) {
      let ret = ''
      if (value > 3) {
        ret = '>3'
      } else if (value < -3) {
        ret = '<-3'
      } else if (value > 0) {
        ret = '+' + value
      } else {
        ret = value
      }
      return ret
    },
    editMeasure (measure) {
      this.$emit('edit', measure)
    },
    deleteMeasure (measure) {
      if (confirm(
        'Вы действительно хотите удалить измерение за ' + measure.dt + '?'
      )) {
        measureDB.remove(measure.id).then(() => {
          for (let i in this.items) {
            if (this.items[i].id === measure.id) {
              this.items.splice(parseInt(i), 1)
              break
            }
          }
        })
      }
    },
    errorMessage (measure) {
      let messages = []
      let years = measureDB.getAgeInYears(this.activeProfile, measure)
      if (years < 2) {
        messages.push('Измерение не будет отражено на графиках (возраст ребёнка на дату измерения меньше 2 лет)')
      } else if (years > 20) {
        messages.push('Измерение не будет отражено на графиках (возраст ребёнка на дату измерения более 20 лет)')
      } else if (measure.weight && (measure.weight < config.graphs.weight.yMin || measure.weight > config.graphs.weight.yMax)) {
        messages.push('Заданный вес не будет отражён на графике, убедитесь, что вы ввели вес в килограммах')
      } else if (measure.stature && (measure.stature < config.graphs.stature.yMin || measure.stature > config.graphs.stature.yMax)) {
        messages.push('Заданный рост не будет отражён на графике, убедитесь, что вы ввели рост в сантиметрах')
      }
      return messages.length > 0 ? messages.join('\n') : ''
    }
  }
}
</script>
